var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachmentImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 103.001,
    height: 30.178,
    viewBox: "0 0 103.001 30.178",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_8809",
    "data-name": "Group 8809",
    transform: "translate(-686.33 -196.084)",
    opacity: 0.78,
    style: {
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8804",
    "data-name": "Group 8804",
    transform: "translate(686.004 199.351)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8803",
    "data-name": "Group 8803",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_36",
    "data-name": "Group 36",
    transform: "matrix(0.996, -0.087, 0.087, 0.996, 1.93, 1.461)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    "data-name": "Group 30",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M15.05,22.433l1.714-18.6-3.658-2.8L1.939,0,0,21.046Z",
    transform: "translate(0 0)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M15.05,22.433l1.714-18.6-3.658-2.8L1.939,0,0,21.046Z",
    transform: "translate(0 0)",
    fill: "#ebf1ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10805",
    "data-name": "Path 10805",
    d: "M14.369,21.623,16.006,3.691,12.513.992,1.851,0,0,20.286Z",
    transform: "translate(0.474 0.5)",
    fill: "#9dbafc",
    opacity: 0.25
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M3.658,2.8,0,0,.959,3.353Z",
    transform: "translate(13.106 1.029)",
    fill: "#9dbafc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_37",
    "data-name": "Group 37",
    transform: "matrix(0.995, -0.105, 0.105, 0.995, 0, 17.277)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 3.158,
    cy: 3.158,
    r: 3.158,
    transform: "translate(0.38 0.379)",
    fill: "#9dbafc"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 2.519,
    cy: 2.519,
    r: 2.519,
    transform: "translate(0 3.123) rotate(-38.308)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M3.113,1.335,2,1.2,2.132.093,1.335,0,1.2,1.111.093.981,0,1.778l1.111.13L.981,3.019l.8.093L1.908,2l1.111.13Z",
    transform: "translate(1.981 1.981)",
    fill: "#9dbafc"
  }))), /*#__PURE__*/React.createElement("line", {
    id: "Line_72",
    "data-name": "Line 72",
    x2: 9.111,
    y2: 0.797,
    transform: "matrix(0.996, -0.087, 0.087, 0.996, 6.541, 5.698)",
    fill: "none",
    stroke: "#9dbafc",
    strokeLinecap: "round",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_73",
    "data-name": "Line 73",
    x2: 9.111,
    y2: 0.797,
    transform: "matrix(0.996, -0.087, 0.087, 0.996, 6.541, 6.959)",
    fill: "none",
    stroke: "#9dbafc",
    strokeLinecap: "round",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_74",
    "data-name": "Line 74",
    x2: 9.111,
    y2: 0.797,
    transform: "matrix(0.996, -0.087, 0.087, 0.996, 6.541, 8.22)",
    fill: "none",
    stroke: "#9dbafc",
    strokeLinecap: "round",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_75",
    "data-name": "Line 75",
    x2: 9.111,
    y2: 0.797,
    transform: "matrix(0.996, -0.087, 0.087, 0.996, 6.541, 9.482)",
    fill: "none",
    stroke: "#9dbafc",
    strokeLinecap: "round",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_76",
    "data-name": "Line 76",
    x2: 9.111,
    y2: 0.797,
    transform: "matrix(0.996, -0.087, 0.087, 0.996, 6.541, 10.743)",
    fill: "none",
    stroke: "#9dbafc",
    strokeLinecap: "round",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_77",
    "data-name": "Line 77",
    x2: 9.111,
    y2: 0.797,
    transform: "matrix(0.996, -0.087, 0.087, 0.996, 6.541, 12.005)",
    fill: "none",
    stroke: "#9dbafc",
    strokeLinecap: "round",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_78",
    "data-name": "Line 78",
    x2: 9.111,
    y2: 0.797,
    transform: "matrix(0.996, -0.087, 0.087, 0.996, 6.541, 13.266)",
    fill: "none",
    stroke: "#9dbafc",
    strokeLinecap: "round",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_79",
    "data-name": "Line 79",
    x2: 4.1,
    transform: "translate(6.541 14.528)",
    fill: "none",
    stroke: "#9dbafc",
    strokeLinecap: "round",
    strokeWidth: 0.3
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_8805",
    "data-name": "Group 8805",
    transform: "translate(717.115 196.334)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4010",
    "data-name": "Rectangle 4010",
    width: 37.741,
    height: 29.678,
    transform: "translate(0 0)",
    fill: "#fff",
    stroke: "#c1d4f8",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10807",
    "data-name": "Path 10807",
    d: "M0,0H34.288V26.7H0Z",
    transform: "translate(1.688 1.201)",
    fill: "#d2e1ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10806",
    "data-name": "Path 10806",
    d: "M138.133,292.013c-1.6-2.175-3.092-2.765-5.091-.856-3.056,2.916-5.263,9.95-7.13,9.435s-1.867-3.431-3.565-5.49-4.583,2.059-9.846,6.69a22.023,22.023,0,0,1-8.657,4.7v3.2h34.288Z",
    transform: "translate(-102.157 -281.55)",
    fill: "#9dbafc"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_198",
    "data-name": "Ellipse 198",
    cx: 4.375,
    cy: 4.375,
    r: 4.375,
    transform: "matrix(0.161, -0.987, 0.987, 0.161, 4.499, 11.59)",
    fill: "#fff"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_8808",
    "data-name": "Group 8808",
    transform: "translate(761.866 200.977)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10812",
    "data-name": "Path 10812",
    d: "M25.46,44.165a.478.478,0,0,1-.477.477H.477A.478.478,0,0,1,0,44.165V25.476A.478.478,0,0,1,.477,25H24.984a.478.478,0,0,1,.477.477Z",
    transform: "translate(0.928 -24.283)",
    fill: "#d2e1ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10833",
    "data-name": "Path 10833",
    d: "M27.315,45.562a.513.513,0,0,1-.511.511H.511A.513.513,0,0,1,0,45.562V25.51A.513.513,0,0,1,.511,25H26.8a.513.513,0,0,1,.511.511Z",
    transform: "translate(0 -24.999)",
    fill: "none",
    stroke: "#c1d4f8",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10813",
    "data-name": "Path 10813",
    d: "M82.5,73.515c0-.524.372-.739.826-.477L91.4,77.7a.5.5,0,0,1,0,.953l-8.077,4.663c-.454.262-.826.048-.826-.477Z",
    transform: "translate(-73.703 -67.641)",
    fill: "#9dbafc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10814",
    "data-name": "Path 10814",
    d: "M84.388,73.654l-1.066-.616c-.454-.262-.826-.048-.826.477v9.327c0,.524.372.739.826.477l1.066-.616Z",
    transform: "translate(-73.703 -67.641)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8806",
    "data-name": "Group 8806",
    transform: "translate(2.407 2.1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10815",
    "data-name": "Path 10815",
    d: "M227.082,41.8a.287.287,0,0,1-.286.286h-2a.287.287,0,0,1-.286-.286v-2a.287.287,0,0,1,.286-.286h2a.287.287,0,0,1,.286.286v2Z",
    transform: "translate(-204.581 -39.513)",
    fill: "#9dbafc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10816",
    "data-name": "Path 10816",
    d: "M227.082,79.3a.287.287,0,0,1-.286.286h-2a.287.287,0,0,1-.286-.286v-2a.287.287,0,0,1,.286-.286h2a.287.287,0,0,1,.286.286v2Z",
    transform: "translate(-204.581 -73.436)",
    fill: "#9dbafc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10817",
    "data-name": "Path 10817",
    d: "M227.082,116.8a.287.287,0,0,1-.286.286h-2a.287.287,0,0,1-.286-.286v-2a.287.287,0,0,1,.286-.286h2a.287.287,0,0,1,.286.286v2Z",
    transform: "translate(-204.581 -107.358)",
    fill: "#9dbafc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10818",
    "data-name": "Path 10818",
    d: "M227.082,154.3a.287.287,0,0,1-.286.286h-2a.287.287,0,0,1-.286-.286v-2a.287.287,0,0,1,.286-.286h2a.287.287,0,0,1,.286.286v2Z",
    transform: "translate(-204.581 -141.281)",
    fill: "#9dbafc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10819",
    "data-name": "Path 10819",
    d: "M227.082,191.793a.287.287,0,0,1-.286.286h-2a.287.287,0,0,1-.286-.286v-2a.287.287,0,0,1,.286-.286h2a.287.287,0,0,1,.286.286v2Z",
    transform: "translate(-204.581 -175.204)",
    fill: "#9dbafc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10820",
    "data-name": "Path 10820",
    d: "M18.093,41.8a.287.287,0,0,1-.286.286h-2a.287.287,0,0,1-.286-.286v-2a.287.287,0,0,1,.286-.286h2a.287.287,0,0,1,.286.286Z",
    transform: "translate(-15.519 -39.513)",
    fill: "#9dbafc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10821",
    "data-name": "Path 10821",
    d: "M18.093,79.3a.287.287,0,0,1-.286.286h-2a.287.287,0,0,1-.286-.286v-2a.287.287,0,0,1,.286-.286h2a.287.287,0,0,1,.286.286Z",
    transform: "translate(-15.519 -73.436)",
    fill: "#9dbafc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10822",
    "data-name": "Path 10822",
    d: "M18.093,116.8a.287.287,0,0,1-.286.286h-2a.287.287,0,0,1-.286-.286v-2a.287.287,0,0,1,.286-.286h2a.287.287,0,0,1,.286.286Z",
    transform: "translate(-15.519 -107.358)",
    fill: "#9dbafc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10823",
    "data-name": "Path 10823",
    d: "M18.093,154.3a.287.287,0,0,1-.286.286h-2a.287.287,0,0,1-.286-.286v-2a.287.287,0,0,1,.286-.286h2a.287.287,0,0,1,.286.286Z",
    transform: "translate(-15.519 -141.281)",
    fill: "#9dbafc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10824",
    "data-name": "Path 10824",
    d: "M18.093,191.793a.287.287,0,0,1-.286.286h-2a.287.287,0,0,1-.286-.286v-2a.287.287,0,0,1,.286-.286h2a.287.287,0,0,1,.286.286Z",
    transform: "translate(-15.519 -175.204)",
    fill: "#9dbafc"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachmentImage);
export default __webpack_public_path__ + "static/media/attachment-image.aa0b4402dfb6eb636a363ab71c3101ee.svg";
export { ForwardRef as ReactComponent };